<template>
    <layout-main :banner="banner" subtitle="移动护理信息系统">
        <template v-slot:content>
            <p class="text">移动护理信息系统基于PDA的患者床边移动信息处理，将条码技术、无线网络技术和移动计算机相结合，实现了条码的身份识别和患者床边信息移动，实现了医嘱的闭环管理。</p>
            <img src="@/assets/nurse/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 识别患者身份、查询与统计患者信息</p>
            <p class="text weight">· 患者护理过程记录，生命体征实时采集，计算功能 (包括出入量、体重指数、输液滴速、预产期等)</p>
            <p class="text weight">· 医嘱查询、执行与统计功能，条码扫描检验标本、175%药、输液标签，耗材的录入和收费</p>
            <p class="text weight">· 药物查询(查询药物剂量、副反应、药物相互作用和药物价格等信息)及化验结果查询等</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/nurse/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0 10px;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
